/**
 * Has to be in a separate file to avoid circular dependencies.
 */

export enum Frequency {
  ProducingDaily = 'producingDaily',
  CalendarDaily = 'calendarDaily',
  Monthly = 'monthly',
  Cumulative = 'cumulative',
}
